<template>
   <!--<div class="offcanvas offcanvas-end border-0" tabindex="-1" id="location" aria-labelledby="locationLabel">-->
   <!--      <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">-->
   <!--         <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>-->
   <!--         <h6 class="offcanvas-title text-white m-0" id="locationLabel">Enter your area or apartment name</h6>-->
   <!--      </div>-->
   <!--      <div class="offcanvas-body">-->
            <!-- search -->
   <!--         <div class="input-group bg-white rounded-3 border py-1">-->
   <!--            <a href="#" class="input-group-text bg-transparent border-0 rounded-0 px-3" id="search"><i class="icofont-search"></i></a>-->
   <!--            <input type="text" class="form-control bg-transparent border-0 rounded-0 ps-0" placeholder="Try J P Nagar, Andheri West etc.." aria-label="Try J P Nagar, Andheri West etc.." aria-describedby="search">-->
   <!--         </div>-->
   <!--         <a href="#" class="link-dark" data-bs-dismiss="offcanvas" aria-label="Close">-->
   <!--            <div class="d-flex align-items-center gap-2 text-primary py-3 border-bottom">-->
   <!--               <i class="icofont-location-arrow"></i>-->
   <!--               <p class="m-0">Use my Current location</p>-->
   <!--            </div>-->
   <!--         </a>-->
            <!-- Saved Address -->
   <!--         <div class="border-bottom py-3">-->
   <!--            <p class="text-black text-uppercase small">Saved Addresses</p>-->
   <!--            <div class="d-flex align-items-center justify-content-between">-->
   <!--               <div class="w-75">-->
   <!--                  <a href="#" class="link-dark" data-bs-dismiss="offcanvas" aria-label="Close">-->
   <!--                     <div class="d-flex align-items-center gap-2 osahan-mb-1">-->
   <!--                        <i class="icofont-ui-home text-muted fs-6"></i>-->
   <!--                        <h6 class="fw-bold mb-0">Home</h6>-->
   <!--                     </div>-->
   <!--                     <p class="text-muted text-truncate mb-0 ps-4">H.No. 2834 Street, 784 Sector, Ludhiana, Punjab</p>-->
   <!--                  </a>-->
   <!--               </div>-->
   <!--               <a href="#" class="link-dark">-->
   <!--                  <div class="bg-light rounded-circle icon-sm">-->
   <!--                     <i class="icofont-share fs-5 text-dark-emphasis"></i>-->
   <!--                  </div>-->
   <!--               </a>-->
   <!--            </div>-->
   <!--         </div>-->
            <!-- recent search -->
   <!--         <div class="py-3">-->
   <!--            <p class="text-black text-uppercase small">Recent Searches</p>-->
   <!--            <a href="#" class="link-dark" data-bs-dismiss="offcanvas" aria-label="Close">-->
   <!--               <div class="d-flex align-items-center gap-2 osahan-mb-1">-->
   <!--                  <i class="icofont-location-pin text-muted fs-6"></i>-->
   <!--                  <h6 class="fw-bold mb-0">Ludhiana</h6>-->
   <!--               </div>-->
   <!--               <p class="text-muted text-truncate mb-0 ps-4">87997 Street, 784 Sector, Ludhiana, Punjab</p>-->
   <!--            </a>-->
   <!--         </div>-->
   <!--      </div>-->
   <!--   </div>-->
      <!-- Search Offcanvas -->
   <!--   <div class="offcanvas offcanvas-bottom border-0 h-100" tabindex="-1" id="searchoffcanvas"-->
   <!--      aria-labelledby="searchoffcanvasLabel">-->
   <!--      <div class="offcanvas-header bg-primary">-->
   <!--         <div class="input-group bg-white rounded-3 border-0 p-0">-->
   <!--            <a href="#" class="input-group-text bg-transparent border-0 rounded-0" id="search" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5"></i></a>-->
   <!--            <input type="text" class="form-control bg-transparent border-0 rounded-0" placeholder="Search for groceries and more" aria-label="Search for groceries and more" aria-describedby="search" value="Chips">-->
   <!--         </div>-->
   <!--      </div>-->
   <!--      <div class="offcanvas-body p-0">-->
   <!--         <div class="row g-0">-->
   <!--            <div class="col-12 border-bottom">-->
   <!--               <h6 class="p-3 m-0">139 result for <span class="fw-bold">"Chips"</span></h6>-->
   <!--            </div>-->
   <!--         </div>-->
   <!--         <div class="row border-bottom g-0">-->
   <!--            <div class="col-6 border-end">-->
   <!--               <div class="card bg-transparent border-0 p-3">-->
   <!--                  <a href="product-detail.html">-->
   <!--                  <img src="img/uncle-chips.png" alt="" class="img-fluid w-75 d-block mx-auto">-->
   <!--                  </a>-->
   <!--                  <div class="card-body p-0">-->
   <!--                     <small class="text-muted">Uncle Chipps</small>-->
   <!--                     <h6 class="card-title fw-bold">Spicy Treat Sweet Chipps</h6>-->
   <!--                     <p class="card-text text-muted">50 g</p>-->
   <!--                  </div>-->
   <!--                  <div-->
   <!--                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
   <!--                     <h6 class="fw-bold m-0">$20</h6>-->
   <!--                     <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
   <!--                  </div>-->
   <!--               </div>-->
   <!--            </div>-->
   <!--            <div class="col-6">-->
   <!--               <div class="card bg-transparent border-0 p-3">-->
   <!--                  <a href="product-detail.html">-->
   <!--                  <img src="img/kurkure.png" alt="" class="img-fluid w-75 d-block mx-auto">-->
   <!--                  </a>-->
   <!--                  <div class="card-body p-0">-->
   <!--                     <small class="text-muted">Kurkura</small>-->
   <!--                     <h6 class="card-title fw-bold">Masala Munch Crips Chipps</h6>-->
   <!--                     <p class="card-text text-muted">40 g</p>-->
   <!--                  </div>-->
   <!--                  <div-->
   <!--                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
   <!--                     <h6 class="fw-bold m-0">$10</h6>-->
   <!--                     <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
   <!--                  </div>-->
   <!--               </div>-->
   <!--            </div>-->
   <!--         </div>-->
   <!--         <div class="row border-bottom g-0">-->
   <!--            <div class="col-6 border-end">-->
   <!--               <div class="card bg-transparent border-0 p-3">-->
   <!--                  <a href="product-detail.html">-->
   <!--                  <img src="img/lays-cream.png" alt="" class="img-fluid w-75 d-block mx-auto">-->
   <!--                  </a>-->
   <!--                  <div class="card-body p-0">-->
   <!--                     <small class="text-muted">Lay'S</small>-->
   <!--                     <h6 class="card-title fw-bold">Lay's Amarican Cream & Onion</h6>-->
   <!--                     <p class="card-text text-muted">73 g</p>-->
   <!--                  </div>-->
   <!--                  <div-->
   <!--                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
   <!--                     <h6 class="fw-bold m-0">$30</h6>-->
   <!--                     <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
   <!--                  </div>-->
   <!--               </div>-->
   <!--            </div>-->
   <!--            <div class="col-6">-->
   <!--               <div class="card bg-transparent border-0 p-3">-->
   <!--                  <a href="product-detail.html">-->
   <!--                  <img src="img/lays-masala.png" alt="" class="img-fluid w-75 d-block mx-auto">-->
   <!--                  </a>-->
   <!--                  <div class="card-body p-0">-->
   <!--                     <small class="text-muted">Lay'S</small>-->
   <!--                     <h6 class="card-title fw-bold">Lay's India's Magic Masala Chips</h6>-->
   <!--                     <p class="card-text text-muted">50 g</p>-->
   <!--                  </div>-->
   <!--                  <div-->
   <!--                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
   <!--                     <h6 class="fw-bold m-0">$20</h6>-->
   <!--                     <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
   <!--                  </div>-->
   <!--               </div>-->
   <!--            </div>-->
   <!--         </div>-->
   <!--         <div class="row border-bottom g-0">-->
   <!--            <div class="col-6 border-end">-->
   <!--               <div class="card bg-transparent border-0 p-3">-->
   <!--                  <a href="product-detail.html">-->
   <!--                  <img src="img/lays-potato.png" alt="" class="img-fluid w-75 d-block mx-auto">-->
   <!--                  </a>-->
   <!--                  <div class="card-body p-0">-->
   <!--                     <small class="text-muted">Lay'S</small>-->
   <!--                     <h6 class="card-title fw-bold">Lay's Hot N Sweet Chiili Potato Chips</h6>-->
   <!--                     <p class="card-text text-muted">50 g</p>-->
   <!--                  </div>-->
   <!--                  <div-->
   <!--                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
   <!--                     <h6 class="fw-bold m-0">$20</h6>-->
   <!--                     <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
   <!--                  </div>-->
   <!--               </div>-->
   <!--            </div>-->
   <!--            <div class="col-6">-->
   <!--               <div class="card bg-transparent border-0 p-3">-->
   <!--                  <a href="product-detail.html">-->
   <!--                  <img src="img/lays-hot-potato.png" alt="" class="img-fluid w-75 d-block mx-auto">-->
   <!--                  </a>-->
   <!--                  <div class="card-body p-0">-->
   <!--                     <small class="text-muted">Lay'S</small>-->
   <!--                     <h6 class="card-title fw-bold">Lay's India's Magic Masala Chips</h6>-->
   <!--                     <p class="card-text text-muted">100 g</p>-->
   <!--                  </div>-->
   <!--                  <div-->
   <!--                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
   <!--                     <h6 class="fw-bold m-0">$70</h6>-->
   <!--                     <a href="cart.html" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
   <!--                  </div>-->
   <!--               </div>-->
   <!--            </div>-->
   <!--         </div>-->
   <!--      </div>-->
   <!--   </div>-->
      <!-- Categories Modal -->
      <div class="modal fade" id="categories" tabindex="-1" aria-labelledby="categoriesLabel" aria-hidden="true">
         <div class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable">
            <div class="modal-content border-0 rounded-4 h-75">
               <div class="modal-header border-0 px-4">
                  <div class="modal-title" id="categoriesLabel">
                     <h5 class="fw-bold text-black mb-1">Shop by categories</h5>
                     <p class="mb-0">categories</p>
                  </div>
               </div>
               <div class="modal-body border-top p-4" v-for="(cat,i) in categories" :key="i">
                  <div class="row row-cols-3 gy-3">
                     <div class="col">
                        <router-link :to="'/'+cat.list" class="link-dark">
                           <div class="card bg-transparent border-0 text-center">
                              <img src="img/category-1.png" alt="" class="card-img-top rounded-4 mb-2">
                              <div class="card-body p-0">
                                 <p class="card-title m-0">{{cat.name}}</p>
                              </div>
                           </div>
                        </router-link>
                     </div>
                   
                  </div>
               </div>
            </div>
         </div>
      </div>
    </template>
    

    <script> 
      import axios from "@/plugins/axios";  
      
      export default {
        name: 'HomeView',
        components: { 
        },
        mounted() {
          // this.initializeHomeContent();
            var $main_nav = $('#main-nav');
          var $toggle = $('.toggle');
          var defaultOptions = {
              disableAt: false,
              customToggle: $toggle,
              levelSpacing: 40,
              navTitle: 'App',
              levelTitles: true,
              levelTitleAsBack: true,
              pushContent: '#container',
              insertClose: 2
          };
          var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
          
              this.fetchWeather();

              this.getHomeBasic();

      
          // this.getHomeBasic(); // Call the method here
      
      
      },
        data() {
          return {
            loading:false,
            error:null,
            business:[],
            property:[],
            categories:[{name:"Event"},{name:"Food"},{name:"Offers"},{name:"News"},{name:"Properties"},],
            listings:[],
            events:[],
            properties:[],
            current_temperature:0,
            isEvent:false,
            isBusiness:false,
            isProperties:false,
            isFood:false,
           
      
      
          }
        },
        methods:{
          initializeHomeContent(){
          
      
          // Coupons
          $('.coupons').slick({
              infinite: false,
              arrows: false,
              autoplay: true,
              slidesToShow: 1.3,
              slidesToScroll: 1,
          });
      
          // Top Picks - Homepage
          $('.top-picks').slick({
              infinite: false,
              arrows: false,
              autoplay: true,
              slidesToShow: 2.3,
              slidesToScroll: 1,
          });
      
          // All Categories - Homepage
          $('.all-cate').slick({
              infinite: false,
              arrows: false,
              autoplay: true,
              slidesToShow: 4.5,
              slidesToScroll: 3,
          });
      
          // Product Detail
          $('.product-slider').slick({
              arrows: false,
              autoplay: true,
              infinite: false,
              dots: true,
          });
          // this.getHomeBasic();
          }
      ,
      async fetchWeather() {
            const url =
              "https://api.open-meteo.com/v1/forecast?latitude=17.6599&longitude=75.9064&hourly=apparent_temperature&timezone=auto&forecast_days=1";
      
            try {
              const response = await fetch(url);
              if (!response.ok) throw new Error("Weather data not available");
              const data = await response.json();
              
              // Get the latest hourly temperature
              if (data.hourly && data.hourly.apparent_temperature.length > 0) {
                this.current_temperature = data.hourly.apparent_temperature[0]; // First hour's temperature
              }
            } catch (error) {
              console.error("Error fetching weather:", error);
            }
          }, 
      
          async getHomeBasic(id="",name="") {
      
           
              this.loading = true;
              this.error = null;
        
              try {
                 var self=this;
                   axios.post('getcanvasview').then((response) => {
                   self.categories = response.data.app_categories;
                  // self.listings = response.data.businesslisting;
                  // self.properties = response.data.properties;
                  console.log(response.data); 
                  
                  
              
                }).then(() => {
                     self.initializeHomeContent();
                }).catch((err) => {
                  
                });;
               
      
              } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
              } finally {
                this.loading = false;
              }
            }, 
        }
      }
      </script>
      
     